import script from "./CheckoutDeliveryOption.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckoutDeliveryOption.vue?vue&type=script&lang=ts&setup=true"

import "./CheckoutDeliveryOption.vue?vue&type=style&index=0&id=ab6a99f2&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab6a99f2"]])

export default __exports__